export enum ClaimType {
  Api = 1,
  Page = 2,
  View = 3,
}
